"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNotificationBody = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var Header_1 = __importStar(require("../../../Header"));
var FontAwesomeIcon_1 = __importStar(require("../../../FontAwesomeIcon"));
var Flex_1 = __importDefault(require("../../../Flex"));
var Box_1 = __importDefault(require("../../../Box"));
exports.StyledNotificationBody = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ", ", " {\n    color: ", ";\n  }\n"], ["\n  ", ", ", " {\n    color: ", ";\n  }\n"])), FontAwesomeIcon_1.StyledFontAwesomeIcon, Header_1.StyledHeader, function (props) { return style_utils_1.colorSelector(props, props.color, 500); });
var COLOR_TO_ICON_CLASS_NAME = {
    danger: "fa-minus-circle",
    primary: "fa-info-circle",
    success: "fa-check-circle",
    warning: "fa-exclamation-circle"
};
var COLOR_TO_MESSAGE = {
    danger: "Error",
    primary: "Info",
    success: "Success",
    warning: "Warning"
};
var NotificationBody = function (_a) {
    var children = _a.children, color = _a.color, icon = _a.icon, subtitle = _a.subtitle, title = _a.title, props = __rest(_a, ["children", "color", "icon", "subtitle", "title"]);
    return (react_1.default.createElement(exports.StyledNotificationBody, __assign({}, props, { color: color }),
        react_1.default.createElement(Flex_1.default, null,
            react_1.default.createElement(Box_1.default, { marginRight: 2 },
                react_1.default.createElement(FontAwesomeIcon_1.default, { iconClassName: icon || COLOR_TO_ICON_CLASS_NAME[color] })),
            react_1.default.createElement(Header_1.default, { size: 5 }, title || COLOR_TO_MESSAGE[color])),
        children,
        subtitle && (react_1.default.createElement("div", { className: "Toastify__subtitle-container" },
            react_1.default.createElement("small", { className: "Toastify__subtitle" }, subtitle)))));
};
exports.default = NotificationBody;
var templateObject_1;
//# sourceMappingURL=index.js.map